import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/endpoints';

/** Polled every 60 s so the health chip in the top bar stays current. */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => api.health.get(),
    refetchInterval: 60_000,
    staleTime: 30_000,
    retry: 1,
  });
}
